// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__tDuIY","content":"styles_content__4FngQ","title":"styles_title__CTJ_d","text":"styles_text__mLSMK","arrow":"styles_arrow__6YXj4"};
module.exports.__checksum = "09a6b07ebaa3"